export default {
  namespaced: true,
  // 局部状态
  state: { // this.$store.state.Sell.height
    height: window.innerHeight - 374,
    heightTitle: window.innerHeight - 382,
    tempBotList: [],
    time: {
      disabledDate (time) { // :picker-options="$store.state.Sell.time"
        return time.getTime() < Date.now() - 8.64e7 // 选择时间范围
        // return time.getTime() > Date.now()
      }
    }
  },
  // 局部读取
  getters: {},
  // 局部变化
  mutations: {},
  // 局部动作
  actions: {}
}
